import { useTranslation } from "react-i18next";
import { IconButton, Tooltip, SvgIcon, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { usePopover } from "@hooks/shared/use-popover";
import { LanguagePopover } from "@components/shared/elements/language-popover";
import { faLanguage } from "@fortawesome/pro-light-svg-icons";

export const LanguageSwitch = () => {
  const popover = usePopover();
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      <Tooltip title={t("common.language")}>
        <IconButton
          data-testid="language-switch"
          onClick={popover.handleOpen}
          ref={popover.anchorRef}
          sx={{
            backgroundColor: popover.open ? alpha(theme.palette.common.white, 0.1) : "transparent",
            color: popover.open ? theme.palette.primary.contrastText : theme.palette.common.white,
            fontWeight: popover.open ? 700 : undefined,
          }}
        >
          <SvgIcon>
            <FontAwesomeIcon icon={faLanguage} color="white" />
          </SvgIcon>
        </IconButton>
      </Tooltip>
      <LanguagePopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
